import React, {useEffect, useState} from 'react';
import api from '../api/axios'; // Dein API-Verwalter
import Cookies from 'js-cookie'; // Bibliothek zum Umgang mit Cookies

const NavBarTopUser = () => {
    const [email, setEmail] = useState(null);  // Zustand für die E-Mail
    const [error, setError] = useState(null);  // Zustand für mögliche Fehler

    // Abruf der Benutzerdaten
    useEffect(() => {
        const fetchUser = async () => {
            try {
                // Access Token aus Cookies abrufen
                const accessToken = Cookies.get('accessToken');

                if (!accessToken) {
                    throw new Error('Access-Token nicht gefunden');
                }

                // Anfrage mit Authorization-Header durchführen
                const {data} = await api.get('/api/v1/user/me', {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                setEmail(data.user.email);  // E-Mail setzen
            } catch (err) {
                setError('Fehler beim Abrufen der Benutzerdaten');
                console.error(err);
            }
        };

        fetchUser();
    }, []);

    if (error) return <div>{error}</div>;

    return (
        <div>
            {email ? <div className='text-sm font-color-4'>{email}</div> : <div>Lädt...</div>}
        </div>
    );
};

export default NavBarTopUser;
